import { useIsMediaMode } from '@/hooks/useIsMediaMode'

/**
 * UI-rendering flag for the CM editor. Channel-level only by design: per-CM
 * media opt-in still persists via `castZodFormToContentModule`, but the
 * streamlined editor layout is reserved for media-mode channels.
 */
export function useEffectiveMediaMode(): { isMediaMode: boolean } {
  return useIsMediaMode()
}
